import {useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';
import {useModal} from 'extensions/viewport/useModal';
import {Prompt} from 'interface/base/Prompt';

export function useModalConflict(submit: (option: string) => void) {
  const {t} = useLingui();
  const modal = useModal();

  const open = useCallback(() => {
    modal.open(
      <Prompt
        title={t`File Conflict`}
        text={t`Files with conflicting names exist in this folder. Choose what to do with duplicate files.`}
        options={{forceChoice: true}}
        buttons={[
          {
            mode: 'primary',
            text: t`Keep both`.toUpperCase(),
            onPress: () => {
              submit('keep');
              modal.exit();
            },
          },
          {
            mode: 'destructive',
            text: t`Replace`.toUpperCase(),
            onPress: () => {
              submit('replace');
              modal.exit();
            },
          },
          {
            mode: 'cancel',
            text: t`Skip`.toUpperCase(),
            onPress: () => {
              submit('skip_with_errors');
              modal.exit();
            },
          },
        ]}
      />
    , {forceChoice: true});
  }, []);

  return {open, exit: modal.exit};
}
